









































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import KriteriaHcuKeluarSection from "@/components/kriteria-hcu/KriteriaHcuKeluarSection.vue";
import KriteriaHcuMasukSection from "@/components/kriteria-hcu/KriteriaHcuMasukSection.vue";
import KriteriaHcuSvc from "@/services/KriteriaHcuService";
import { appModule } from "@/store/modules/app";
import { storeKriteriaHcu } from "@/store/modules/KriteriaHcuStore";
import { userModule } from "@/store/modules/user";

@Component({
	components: {
		KriteriaHcuMasukSection,
		KriteriaHcuKeluarSection,
	},
	inject: {
		isReadOnly: { default: () => () => false },
	},
})
export default class KriteriaHcuPage extends Vue {
	@Prop() register!: string | number;
	isReadOnly!: () => boolean;

	get readOnly(): boolean {
		return this.isReadOnly();
	}
	@Prop() rm!: string | number;
	@Prop({ default: false }) isActive!: boolean;
	//  "all" = tampilkan semua step; "masuk"/"keluar" untuk split tab di IcuHcuPage
	@Prop({ default: "all" }) phase!: "masuk" | "keluar" | "all";

	deleteDialog = false;
	deleting = false;
	loaded = false;

	get kriteriaHcu() {
		return storeKriteriaHcu.currentItem;
	}

	get loading() {
		return storeKriteriaHcu.loading;
	}

	get isCreator(): boolean {
		const rec: any = this.kriteriaHcu;
		return !!rec && !!rec.created_by && Number(rec.created_by) === Number(userModule.user.id);
	}

	get canDelete(): boolean {
		const rec: any = this.kriteriaHcu;
		if (!rec || !rec.id || this.readOnly) {
			return false;
		}
		return !rec.masuk_signed_at || this.isCreator;
	}

	get isMasukComplete() {
		return !!this.kriteriaHcu?.masuk_signed_at;
	}

	//  Blanko 2026: lembar keluar selesai setelah PPJA DAN DPJP menandatangani.
	get isKeluarComplete() {
		return !!this.kriteriaHcu?.is_checklist_locked;
	}

	//  TTD pertama (PPJA) sudah dibubuhkan — lembar terkunci, menunggu DPJP.
	get isKeluarSigned() {
		return !!this.kriteriaHcu?.cl_ppja_signed_at;
	}

	@Watch("isActive", { immediate: true })
	onActiveChange(val: boolean) {
		if (val && !this.loaded) {
			this.fetchData();
			this.loaded = true;
		}
	}

	async fetchData() {
		await storeKriteriaHcu.getByRegister(this.register);
	}

	async onSaved(data: any) {
		if (data?.id) {
			await storeKriteriaHcu.refresh(data.id);
		}
	}

	async onSigned() {
		//  Pada form baru, TTD bisa terjadi sebelum store sempat terisi hasil create
		//  (doSign menyimpan senyap lalu langsung TTD), jadi id-nya belum ada di sini —
		//  ambil ulang lewat register supaya masuk_signed_at benar-benar masuk dan
		//  tab Kriteria Keluar ikut terbuka.
		if (this.kriteriaHcu?.id) {
			await storeKriteriaHcu.refresh(this.kriteriaHcu.id);
		} else {
			await storeKriteriaHcu.getByRegister(this.register);
		}
	}

	printPdfMasuk() {
		if (this.kriteriaHcu?.id) {
			KriteriaHcuSvc.printPdfMasuk(this.kriteriaHcu.id);
		}
	}

	printPdfKeluar() {
		if (this.kriteriaHcu?.id) {
			KriteriaHcuSvc.printPdfKeluar(this.kriteriaHcu.id);
		}
	}

	confirmDelete() {
		this.deleteDialog = true;
	}

	async doDelete() {
		this.deleting = true;
		try {
			const resp = await KriteriaHcuSvc.destroy(this.kriteriaHcu.id);
			if (resp?.data?.status === "1") {
				appModule.NoticeDelay("Berhasil menghapus kriteria HCU");
				storeKriteriaHcu.reset();
				this.deleteDialog = false;
			}
		} catch (e) {
			// Error handled by service
		}
		this.deleting = false;
	}

	beforeDestroy() {
		storeKriteriaHcu.reset();
	}
}
